import React, { Component } from 'react';
import { Label } from '@fluentui/react';
import * as msg from './Helper/Const';

export class EventExpired extends Component {

    render() {
        return (
            <div className="formColumnRight">
                <div>
                    <Label className="subtitle">{msg.EventExpiredTitle}</Label>
                    <br />
                    <Label className="labelInfo">{msg.EventExpiredMsg}</Label>
                 </div> 
            </div>
        );
    }
}